import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ExpertContainer,
  ExpertWrapper,
  ExpertContent,
  ExpertTopLine,
  ExpertHeading,
  ExpertText,
  ExpertBtnWrap,
  ExpertImgWrap,
  ExpertImg,
  ExpertImgPlaceholder,
} from './ExpertSectionElements';

const portfolioBtnStyle = {
  borderRadius: '50px',
  background: '#01BF71',
  whiteSpace: 'nowrap',
  padding: '12px 30px',
  color: '#010606',
  fontSize: '16px',
  fontWeight: '600',
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.2s ease-in-out',
};

const ExpertSection = ({
  id,
  topLine,
  heading,
  description,
  image,
  imageAlt,
  placeholderText,
  portfolioLink,
  portfolioLabel = 'View portfolio',
}) => {
  const [imgError, setImgError] = useState(false);

  return (
    <ExpertContainer id={id}>
      <ExpertWrapper>
        <ExpertContent>
          <ExpertTopLine>{topLine}</ExpertTopLine>
          <ExpertHeading>{heading}</ExpertHeading>
          <ExpertText>{description}</ExpertText>
          {portfolioLink && (
            <ExpertBtnWrap>
              <Link
                to={portfolioLink}
                className="expert-portfolio-btn"
                style={portfolioBtnStyle}
                onMouseEnter={(e) => {
                  e.target.style.background = '#fff';
                  e.target.style.color = '#010606';
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = '#01BF71';
                  e.target.style.color = '#010606';
                }}
              >
                {portfolioLabel}
              </Link>
            </ExpertBtnWrap>
          )}
        </ExpertContent>
        <ExpertImgWrap>
          {!imgError ? (
            <ExpertImg
              src={image}
              alt={imageAlt}
              onError={() => setImgError(true)}
            />
          ) : (
            <ExpertImgPlaceholder>{placeholderText}</ExpertImgPlaceholder>
          )}
        </ExpertImgWrap>
      </ExpertWrapper>
    </ExpertContainer>
  );
};

export default ExpertSection;
